const TABLE_CONVERSIONS = [
  ['datetime', (d => new Date(d))],
  ['date',     (d => new Date(d))],
];

export default {
  table_to_meteo(table) {
    // table is [{register}, {register}]
    // returns [{register}, {register}] with proper data formats
    function process_register(reg) {
      for (const [key, func] of TABLE_CONVERSIONS)
        if (reg[key])
          reg[key] = func(reg[key]);
      return reg
    }
    return table.filter(l => !!l.datetime || !!l.date).map(process_register);
  },
}
